export default __webpack_public_path__ + "static/media/k_wdt_c_7.339ca059.mp3";